export class BusquedaEncuesta {
  aliasEncuesta: string;
  resourceKeyPantalla: string;
  idUsuario: number;
  idPaisUsuario: number;
  idCliente: number;
  idPaisCliente: number;
  
  constructor(
    aliasEncuesta: string,
    resourceKeyPantalla: string,
    idUsuario: number,
    idPaisUsuario: number,
    idCliente: number,
    idPaisCliente: number
  ) {
    this.aliasEncuesta = aliasEncuesta;
    this.resourceKeyPantalla = resourceKeyPantalla;
    this.idUsuario = idUsuario;
    this.idPaisUsuario = idPaisUsuario;
    this.idCliente = idCliente;
    this.idPaisCliente = idPaisCliente;
  }
}